module.exports = __webpack_public_path__ + "img/cg_mechanical_arm.9196364d.jpg";